import { render, staticRenderFns } from "./TripDetails.vue?vue&type=template&id=4d324ddc"
import script from "./TripDetails.vue?vue&type=script&lang=js"
export * from "./TripDetails.vue?vue&type=script&lang=js"
import style0 from "./TripDetails.vue?vue&type=style&index=0&id=4d324ddc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports